import { BRAND } from "../../constants/brand";
import React from "react";
import { Row, Col, Card, Image } from "antd";
import styles from "./index.module.scss";
import MainLayout from "../../components/layout/main-layout";
import bannerImage3 from "../../assets/imrpintbannernew.png";
import ButtonComponent from "../../components/common/button";
import bannerImage from "../../assets/bgHand.png";
import { Content } from "antd/es/layout/layout";
import UnfollowSeries from "./components/UnfollowSeries";
import BuddyhoodSlider from "./components/buddyhoodSlider";

const Origin = () => {
  return (
    <MainLayout>
      <Content>
        <div
          id="herobanner"
          style={{
            background: `url(${bannerImage3}) no-repeat top center/cover`,
          }}
        >
          <div className={styles.heroBanner}>
            <div className={styles.overlay}>
              <h1>
                {BRAND.domainLabel}'s{"  "}
                <span className={styles.highlight}>Origin Story</span>
              </h1>
              <p>
                {" "}
                The Buddyhood created {BRAND.domainLabel} in The UNFOLLOW Series as
                every story matters.
              </p>
            </div>
          </div>
        </div>
      </Content>
      <Content>
        <UnfollowSeries />
      </Content>
      <Content>
        <BuddyhoodSlider />
      </Content>

      <div id="hero" className={styles.storyContainer}>
        <Row
          gutter={[32, 32]}
          align="middle"
          justify="center"
          className={styles.storyRow}
        >
          <Col xs={22} sm={20} md={16} lg={14} className={styles.textSection}>
            <Card bordered={false} className={styles.cardContent}>
              <h2>Stories make us human</h2>
              <p>
                Stories are how we have always made sense of the world. Now more
                than ever, as we evolve and navigate a new era in which we
                coexist with technology, stories are fundamental to what makes
                us human.
              </p>
              <p>
                Our platform is designed to help nurture true friendship –
                Buddyhood – where everyone feels they can belong in even the
                most unsettling of times. Our purpose is to be a buddy to our
                users to help them feel supported so that they can thrive.
              </p>
              {/* <p>
                Stories define how future dialogues made us one of the world's
                most interactive species. From the book cover, ad, a website and
                moving into reels as a hub that reveals what binds technology
                solutions to fundamentals in what makes us human.
              </p>
              <p>
                Our in-depth, high human AI is a facilitating study proof –
                which everyone loves. They can bask in even the most small tiny
                written lines. Our purpose in this is to study our readers to
                help them fully appreciate what they carry today. */}
              {/* </p> */}
            </Card>
          </Col>

          {/* Image Section */}
          <Col xs={22} sm={20} md={16} lg={10} className={styles.imageSection}>
            <Image
              src="/Images/stories.png"
              alt="Illustration"
              className={styles.storyImage}
              loading="lazy"
              preview={false}
            />
          </Col>
        </Row>
      </div>

      <div
        id="buddyhood-section"
        className={styles.buddyhoodContainer}
        style={{
          background: `url(${bannerImage}) no-repeat center center/cover`,
        }}
      >
       <Image
              src="/Images/buddyhoodlogo.png"
              alt="Illustration"
              className={styles.storyImage}
              loading="lazy"
              preview={false}
            />
        <p className={styles.subtitle}>
          An independent publishing house that shares stories with purpose to:
        </p>

        <Row gutter={[16, 16]} justify="center" className={styles.cardsRow}>
          <Col xs={22} sm={20} md={8} lg={6}>
            <div className={styles.infoCard}>
              <div className={styles.imgbox}>
                <Image
                  src="/Images/Empower.png"
                  alt="Empower"
                  className={styles.icon}
                  loading="lazy"
                  preview={false}
                />
              </div>
              <div className={styles.redBox}>
                <h3>EMPOWER</h3>
              </div>
            </div>
          </Col>
          <Col xs={22} sm={20} md={8} lg={6}>
            <div className={styles.infoCard}>
              <div className={styles.imgbox}>
                <Image
                  src="/Images/Educate.png"
                  alt="Educate"
                  className={styles.icon}
                  loading="lazy"
                  preview={false}
                />
              </div>
              <div className={styles.yellowBox}>
                <h3>EDUCATE</h3>
              </div>
            </div>
          </Col>
          <Col xs={22} sm={20} md={8} lg={6}>
            <div className={styles.infoCard}>
              <div className={styles.imgbox}>
                <Image
                  src="/Images/entertain.png"
                  alt="Inspire"
                  className={styles.icon}
                  loading="lazy"
                  preview={false}
                />
              </div>
              <div className={styles.blueBox}>
                <h3>INSPIRE</h3>
              </div>
            </div>
          </Col>
        </Row>

        <p className={styles.description}>
          Each story raises awareness and gives back to charitable causes that
          can drive positive change.
        </p>
        <a
          href="https://www.thebuddyhood.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <ButtonComponent
            {...{
              type: "primary",
              text: "About Our Mission",
              variant: "gold",
            }}
          />
        </a>
      </div>

      {/* <AuthFooterComponent />
      <span className="app-version">v{process?.env?.version}</span> */}
    </MainLayout>
  );
};

export default Origin;
